<script setup lang="ts">
import { Toaster } from '@/components/shadcn'
import type { ToasterProps } from 'vue-sonner'

const props = withDefaults(
  defineProps<ToasterProps>(),
  {
    position: 'top-center',
    expand: true,
    richColors: true,
    closeButton: false,
  },
)
</script>

<template>
  <Toaster v-bind="props" />
</template>

